import React from "react";

import { Popover, message, Button } from "antd";

import { Link, Switch, Route } from "react-router-dom";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";

import phone from "@/assets/images/app-phone.png";
import androidBtn from "@/assets/images/android-btn.png";
import iosBtn from "@/assets/images/ios-btn.png";
import MyIcon from "@/components/MyIcon";
import "./index.less";
import QRCode from "qrcode.react";

const IOSUrl = "https://apps.apple.com/cn/app/mempool%E7%9F%BF%E6%B1%A0/id1478407318";
// const AndroidUrl = "https://pool.mempool.com/download/mempool_v1.0.0.apk";
interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "locale", "router")
@observer
class AppContainer extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}
  toDownload() {
    window.open(IOSUrl);
  }

  render() {
    const { locale } = this.props;
    return (
      <div className="app-container-page">
        <div className="center">
          <div className="app-block">
            <span>{locale.get("Footer.Pool")}APP</span>
            <span className="app-info">
              {locale.get("login.appText1")}
              <br></br>
              {locale.get("login.appText2")}
              <br></br>
              {locale.get("login.appText3")}
              <br></br>
              {locale.get("login.appText4")}
              <br></br>
            </span>
            <div className="btn-group">
              <img className="img-btn" src={iosBtn} onClick={this.toDownload}></img>
              <Popover
                placement="rightBottom"
                content={
                  <div>
                    <QRCode value={this.props.session.link || ""} />
                  </div>
                }
              >
                <img className="img-btn" src={androidBtn}></img>
              </Popover>
            </div>
          </div>
          <img className="img-phone" src={phone}></img>
        </div>
      </div>
    );
  }
}

export default AppContainer as React.ComponentType;
